import gql from 'graphql-tag';

export const CERTIFICATION_COST_CODE_FRAGMENT = gql`
  fragment CertificationCostCode on CertificationCostCode {
    id
    certificationId
    certification {
      name
    }
    createdOn
    deletedOn
    costCodeId
  }
`;
